<template>
    <div class="kgk-invalidate-run-form">
        <h3 v-if="!insideModal">
            Lauf invalidieren
        </h3>
        <div v-if="!detailsLoading && run">
            <form @submit.prevent="invalidateRun">
                <div class="kgk-form-row col-half">
                    <div><b>Distanz:</b></div>
                    <i class="fas fa-running"></i> {{ convertNumberReadable(Math.round(run.length * 100) / 100) }} km
                </div>
                <div class="kgk-form-row col-half">
                    <div><b>Dauer:</b></div>
                    <i class="fas fa-stopwatch"></i> {{ durationReadable(run.duration) }}
                </div>
                <div class="kgk-form-row col-half">
                    <div><b>Pace:</b></div>
                    {{ convertNumberReadable(Math.round((run.duration / 60) / run.length * 100) / 100) }} min/km
                </div>
                <div class="kgk-form-row col-half">
                    <div><b>Zeitpunkt:</b></div>
                    <i class="fas fa-calendar-alt"></i> {{ convertDateReadable(run.ran_at) }} <i class="fas fa-clock"></i> {{ convertTimeReadable(run.ran_at) }}
                </div>

                <div class="kgk-form-row">
                    <div v-if="run.screenshot_url" class="kgk-upload-preview">
                        <a :href="run.screenshot_url" @click.prevent="">
                            <img :src="run.screenshot_url">
                        </a>
                        <!--<VuePureLightbox
                                :thumbnail="run.screenshot_url"
                                :images="[run.screenshot_url]"
                        />-->
                    </div>
                </div>

                <div class="kgk-form-row custom-message">
                    <div>
                        &raquo; Hallo <i>Vorname</i>!<br>
                        Leider wurde der hochgeladene Nachweis für deinen Lauf vom {{ convertDateReadable(run.ran_at) }}, {{ convertTimeReadable(run.ran_at) }} Uhr über {{ convertNumberReadable(Math.round(run.length * 100) / 100) }} Kilometer als unzureichend eingestuft.
                    </div>
                    <textarea v-model="message" placeholder="Benutzerdefinierte Nachricht (optional)" rows="3"></textarea>
                    <div>
                        <span style="text-decoration:underline;">Jetzt einloggen</span>, um erneut ein Nachweisfoto oder -screenshot hochzuladen und es damit noch einmal zu versuchen. &laquo;
                    </div>
                </div>

                <div v-if="!insideModal" class="kgk-form-row">
                    <button type="submit">
                        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                        <span class="button-text">Lauf invalidieren</span>
                    </button>
                </div>
            </form>
        </div>
        <div v-else-if="detailsLoading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
</template>

<script>
    import admin from '../../api/admin';

    export default {
        name: 'InvalidateRunForm',
        components: {

        },
        props: {
            insideModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
            runIdentifier: {
                type: String,
                required: false
            },
        },
        data() {
            return {
                detailsLoading: false,
                loading: false,
                run: null,
                message: '',
                error: '',
            }
        },
        computed: {

        },
        methods: {
            durationReadable(duration) {
                const hours = Math.floor(duration / 60 / 60);
                const minutes = Math.floor((duration % (60 * 60)) / 60);
                const seconds = duration % 60;

                //return (hours > 0 ? hours + ':' : '') + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
                return hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
            },

            invalidateRun(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }


                this.loading = true;

                //if( calledFromModal ) {
                this.$emit('loadingStarted');
                //}


                admin.invalidateRun(
                    this,
                    this.runIdentifier,
                    this.message,
                    () => {
                        this.$notify({
                            type: 'success',
                            title: 'Lauf invalidiert',
                            text: `Der Lauf wurde erfolgreich invalidiert.`
                        });

                        this.$emit('invalidated');
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 || (typeof e.response.data !== 'undefined' && typeof e.response.data.message !== 'undefined') ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        //if( calledFromModal ) {
                        this.$emit('loadingEnded');
                        //}
                    }
                );

                return true;
            },

        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.invalidateRun();
                /*const result = this.invalidateRun(true);
                if( result === true ) {

                }*/
            },
        },
        mounted() {
            if( !this.runIdentifier ) {
                console.error('InvalidateRunForm requires passing of a run identifier');
                return;
            }

            this.detailsLoading = true;

            admin.getRun(
                this,
                this.runIdentifier,
                ({run}) => {
                    this.run = run;

                    /*this.form.editIdentifier = run.identifier;
                    this.form.length = this.convertNumberReadable(run.length);

                    this.form.duration.hours   = '' + Math.floor(run.duration / 60 / 60);
                    //if( this.form.duration.hours === '0' ) {
                    //    this.form.duration.hours = null;
                    //}
                    this.form.duration.minutes = '' + Math.floor((run.duration % (60 * 60)) / 60);
                    this.form.duration.seconds = '' + run.duration % 60;

                    this.form.ran_at.date = run.ran_at.split(' ')[0] + 'T00:00:00.000';
                    this.form.ran_at.time = (new Date().toJSON()).split('T')[0] + 'T' + run.ran_at.split(' ')[1] + '.000';

                    this.form.screenshot_url = run.screenshot_url;*/

                    this.isInvalidated = !!run.invalidated;
                },
                () => {
                    this.$notify({
                        type: 'error',
                        title: 'Es ist ein unbekannter Fehler aufgetreten.',
                        text: 'Bitte versuch es noch einmal.'
                    });

                    if( this.insideModal ) {
                        this.$emit('modalForceClose');
                    }
                },
                () => this.detailsLoading = false,
            );
        }


    }
</script>

